import React from 'react';
export function AuthorSection() {
  return <section className="w-full bg-pinkLight px-5 py-10 md:py-16" aria-labelledby="author-heading" data-id="element-16">
      <div className="mx-auto max-w-container" data-id="element-17">
        <div className="flex flex-col items-center gap-6 md:flex-row md:items-start md:gap-8" data-id="element-18">
          <div className="flex flex-col items-center md:w-[140px] md:shrink-0" data-id="element-19">
            <div className="relative h-[120px] w-[120px] overflow-hidden rounded-full ring-4 ring-white" style={{
            boxShadow: '0 8px 20px rgba(75,21,40,0.15)'
          }} data-id="element-20">
              <img src="https://cdn.magicpatterns.com/uploads/vFunkMNE4pUtGPJkhY7xHC/ella_habla_del_producto_y_202605041106.jpg" alt="Fundadora de Vitalízate Ahora" className="h-full w-full object-cover" style={{
              objectPosition: '50% 22%'
            }} data-id="element-21" />
            </div>
            <p className="mt-3 text-center text-[12px] leading-tight text-burgundy" data-id="element-22">
              Fundadora de
              <br data-id="element-23" />
              Vitalízate Ahora
            </p>
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-24">
            <h3 id="author-heading" className="font-serif text-[20px] font-medium text-wine md:text-[22px]" data-id="element-25">
              ¿Por qué confiar en esta guía?
            </h3>
            <p className="mt-4 text-[14px] text-burgundy" style={{
            lineHeight: 1.7
          }} data-id="element-26">
              Llevo años investigando qué funciona realmente para las mujeres
              latinas en esta etapa. No soy doctora, soy alguien que ha visto a
              su madre, sus hermanas y sus amigas pasar por lo mismo. Esta guía
              recopila lo que sí da resultados: nutrición específica, rutinas
              simples y respeto por tu cuerpo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}